import React, { useState } from 'react';

const Contact = () => {
  const [btnText, setBtnText] = useState('Gönder');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setBtnText('Gönderiliyor...');
    setTimeout(() => {
      setBtnText('Talebiniz Alındı!');
      setSubmitted(true);
      e.target.reset();
      
      setTimeout(() => {
        setBtnText('Gönder');
        setSubmitted(false);
      }, 3000);
    }, 1500);
  };

  return (
    <section id="contact" className="contact">
      <div className="container reveal">
        <div className="contact-card">
          <div className="contact-info-panel">
            <h2>Bizimle İletişime Geçin</h2>
            <p>Uzman mühendislerimiz size en uygun maliyet/performans oranına sahip çözümü sunmak için hazır.</p>
            <div className="c-items mt-4">
              <div className="c-item">
                <i className="fa-solid fa-location-dot"></i>
                <div>
                  <h5>Fabrika</h5>
                  <span>Sultan Orhan Mahallesi 1185. Sokak No: 10 Gebze / Kocaeli</span>
                </div>
              </div>
              <div className="c-item">
                <i className="fa-solid fa-phone-volume"></i>
                <div>
                  <h5>Telefon</h5>
                  <a href="https://wa.me/905470013478" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.5rem' }}><i className="fa-brands fa-whatsapp" style={{ color: '#25d366' }}></i>0547 001 34 78</a>
                </div>
              </div>
              <div className="c-item">
                <i className="fa-solid fa-envelope"></i>
                <div>
                  <h5>E-Posta</h5>
                  <span>info@nettesttestere.com</span>
                </div>
              </div>
            </div>
          </div>
          <div className="contact-form-panel">
            <h3>Online Teklif Alın</h3>
            <form onSubmit={handleSubmit} id="lead-form">
              <div className="form-group">
                <input type="text" placeholder="Adınız Soyadınız" required />
              </div>
              <div className="form-group">
                <input type="text" placeholder="Firma Adı" required />
              </div>
              <div className="form-group">
                <input type="email" placeholder="E-Posta Adresi" required />
              </div>
              <div className="form-group">
                <select defaultValue="" required>
                  <option value="" disabled>İlgilendiğiniz Ürün Grubu</option>
                  <option value="serit">Şerit Testereler</option>
                  <option value="daire">Daire Testereler</option>
                  <option value="kaynak">Kaynak Testleri ve Hizmetleri</option>
                </select>
              </div>
              <div className="form-group">
                <textarea rows="4" placeholder="Mesajınız veya Firmanızın İhtiyacı..." required></textarea>
              </div>
              <button 
                type="submit" 
                className="btn-primary w-100" 
                style={submitted ? {backgroundColor: '#10b981'} : {}}
              >
                {btnText}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
